<template>
  <aside class="processing-wait-card" role="status" aria-live="polite">
    <div class="processing-wait-icon" aria-hidden="true">
      <i class="fa-solid fa-spinner"></i>
    </div>
    <div class="processing-wait-content">
      <p class="processing-wait-title">{{ currentTitle }}</p>
      <p class="processing-wait-message">{{ currentMessage }}</p>
      <div class="processing-wait-bar" aria-hidden="true">
        <span></span>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "ProcessingWaitNotice",
  props: {
    extended: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Elaborazione in corso",
    },
    message: {
      type: String,
      default:
        "Mantieni aperta questa pagina, aggiorneremo automaticamente lo stato della conversione.",
    },
    extendedTitle: {
      type: String,
      default: "Stiamo ultimando l'estrazione",
    },
    extendedMessage: {
      type: String,
      default:
        "La conversione è in corso. Alcuni file più grandi possono richiedere più tempo.",
    },
  },
  computed: {
    currentTitle() {
      return this.extended ? this.extendedTitle : this.title;
    },
    currentMessage() {
      return this.extended ? this.extendedMessage : this.message;
    },
  },
};
</script>

<style scoped>
.processing-wait-card {
  position: absolute;
  top: 28.6rem;
  left: 50%;
  z-index: 20;
  width: min(24rem, calc(100% - 2rem));
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.85rem;
  align-items: start;
  box-sizing: border-box;
  margin: 0;
  padding: 0.95rem 1rem;
  color: #26313d;
  background: #f7fafc;
  border: 1px solid #d7e4ee;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(30, 45, 60, 0.12);
  pointer-events: none;
  transform: translateX(-50%);
}

.processing-wait-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  color: #1474bd;
  background: #e8f3fb;
  border: 1px solid #c4dff2;
  border-radius: 50%;
}

.processing-wait-icon i {
  animation: processing-spin 1.1s linear infinite;
}

.processing-wait-content {
  min-width: 0;
}

.processing-wait-title {
  margin: 0 0 0.25rem;
  color: #1f2a35;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
}

.processing-wait-message {
  margin: 0;
  color: #4a5663;
  font-size: 0.88rem;
  line-height: 1.45;
}

.processing-wait-bar {
  position: relative;
  height: 0.28rem;
  margin-top: 0.8rem;
  overflow: hidden;
  background: #dfe9f1;
  border-radius: 999px;
}

.processing-wait-bar span {
  position: absolute;
  inset: 0 auto 0 0;
  width: 38%;
  background: #1474bd;
  border-radius: inherit;
  animation: processing-slide 1.45s ease-in-out infinite;
}

@keyframes processing-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes processing-slide {
  0% {
    transform: translateX(-110%);
  }
  55% {
    transform: translateX(120%);
  }
  100% {
    transform: translateX(280%);
  }
}

@media (max-width: 520px) {
  .processing-wait-card {
    grid-template-columns: 1fr;
    top: 27.5rem;
    width: min(21rem, calc(100% - 1rem));
  }

  .processing-wait-icon {
    width: 2rem;
    height: 2rem;
  }
}
</style>
